import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SearchBar from '../../SearchBar/SearchBar';
import './DashboardHeader.scss';
import { Routes } from '../../../utils';
import { SearchTypeEnum } from '../../../types/SearchTypeEnum';

const DashboardHeader = (): React.ReactElement => {
    const [activeButton, setActiveButton] = useState<string>('Dashboard');
    const location = useLocation();
    const handleButtonClick = (buttonName: string) => {
        setActiveButton(buttonName);
    };

    useEffect(() => {
        const currentPath = location.pathname;
        if (currentPath === Routes.DASHBOARD_VOS.route) {
            setActiveButton('Billing');
        } else if (currentPath === Routes.DASHBOARD_MAP.route) {
            setActiveButton('Map');
        } else {
            setActiveButton('Dashboard');
        }
    });
    return (
        <div className="Header-Container">
            {/* <div className="Header-SearchBar">
                <SearchBar type={SearchTypeEnum.Load}></SearchBar>
            </div> */}
            <div className="Header-ListHeader">
                <div className="JobProfile-HeaderTitle"></div>

                <div className="Row JobProfile-ToggleButtonsContainer">
                    {/* <Link
                            className="JobProfile-LeftToggleButton JobProfile-ButtonText"
                            to={{ pathname: `${Routes.JOB_PROFILE.route}${1}` }}
                        >
                            Dashboard (CA)
                        </Link> */}
                    {/* <div className="JobProfile-LeftToggleButton JobProfile-ButtonText">
                        <p className="JobProfile-ButtonText">Dashboard</p>
                    </div> */}
                    {/* <div className="JobProfile-MiddleToggleButton JobProfile-ButtonText ">
                        <p className="JobProfile-ButtonText">Map</p>
                    </div> */}
                    <div onClick={() => handleButtonClick('Dashboard')}>
                        <Link
                            to={{
                                pathname: `${Routes.DASHBOARD.route}`,
                            }}
                            className={`JobProfile-LeftToggleButton JobProfile-ButtonText  ${
                                activeButton === 'Dashboard' ? 'JobProfile-ActiveButton' : ''
                            }`}
                        >
                            Dashboard
                        </Link>
                    </div>
                    <div onClick={() => handleButtonClick('Map')}>
                        <Link
                            to={{
                                pathname: `${Routes.DASHBOARD_MAP.route}`,
                            }}
                            className={`JobProfile-MiddleToggleButton JobProfile-ButtonText  ${
                                activeButton === 'Map' ? 'JobProfile-ActiveButton' : ''
                            }`}
                        >
                            Map
                        </Link>
                    </div>
                    <div onClick={() => handleButtonClick('Billing')}>
                        <Link
                            to={{
                                pathname: `${Routes.DASHBOARD_VOS.route}`,
                            }}
                            className={`JobProfile-RightToggleButton JobProfile-ButtonText ${
                                activeButton === 'Billing' ? 'JobProfile-ActiveButton' : ''
                            }`}
                        >
                            Billing
                        </Link>
                    </div>
                    {/* <div className="JobProfile-RightToggleButton JobProfile-ButtonText" >
                    <Link
                    to={{
                        pathname: `${Routes.DASHBOARD_VOS.route}`,
                    }}
                    className="JobProfile-RightToggleButton JobProfile-ButtonText JobProfile-ActiveButton">
                
                    
                    Billing
                </Link>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default DashboardHeader;
